// src/belediye/hooks/usePermissions.js
//
// FAZ-12 — izin sorgu ailesi. uiOn=false iken çağıranlar eski yolda kalmalı
// (Gate/Guard bileşenleri pasifleşir); can() ailesi yine doğru cevap verir
// ama FAZ-12'de kimse karar bağlamaz (FAZ-13 cutover'ın işi).

import { useMemo } from "react";
import { useSelector } from "react-redux";

import { selectAuthz } from "../redux/slices/authzSlice";
import { computeUiOn } from "../utils/authzStorage";

export function buildPermissionApi(authz) {
  const permissions = Array.isArray(authz?.permissions) ? authz.permissions : [];
  const set = new Set(permissions);
  const isSuperUser = authz?.isSuperUser === true;

  // superuser rol sisteminin dışındadır (F0 kararı) — her kapıdan geçer.
  const can = (code) => isSuperUser || set.has(code);
  const canAny = (codes) => isSuperUser || (Array.isArray(codes) && codes.some((c) => set.has(c)));
  const canAll = (codes) => isSuperUser || (Array.isArray(codes) && codes.every((c) => set.has(c)));

  return {
    can,
    canAny,
    canAll,
    permissions,
    scope: authz?.scope || null,
    globalRole: authz?.globalRole ?? null, // /me.global_role → { code, name }
    isSuperUser,
    uiProfile: authz?.uiProfile ?? null, // FAZ-17 — dashboard görünüm varyantı
    uiOn: computeUiOn(authz?.enabledModules, permissions),
  };
}

export default function usePermissions() {
  const authz = useSelector(selectAuthz);
  return useMemo(() => buildPermissionApi(authz), [authz]);
}
